<script>
    import UserInput from './input';
    import WidgetHeader from './header';

    export default {
        components: { UserInput, WidgetHeader },

        props: {
            application: {
                type: Object,
                required: true
            }
        }
    }
</script>

<template>

    <div class="sc-chat-window isOpen">

        <div class="sc-chat-window__header">
            <widget-header
                :application="application"
            />
        </div>

        <div class="sc-chat-window__body">

        </div>

        <div class="sc-chat-window__footer">
            <user-input/>
        </div>
    </div>
</template>

<style scoped lang="scss">

    .sc-chat-window {
        right: 25px;
        bottom: 45px;
        box-sizing: border-box;
        background: white;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        transition: 0.3s ease-in-out;
        font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
        flex-flow: column;
        z-index: 2147483000;
        position: fixed;
        width: 376px;
        min-height: 250px;
        max-height: 704px;
        box-shadow: rgba(0, 0, 0, 0.16) 0 5px 40px;
        opacity: 1;
        height: calc(100% - 120px);
        border-radius: 8px;
        overflow: hidden;

        &__header {
            flex: 0 1 auto;
        }

        &__body {
            flex: 1 1 auto;
            overflow-y: auto;
        }

        &__footertop {
            flex: 0 1 10px;
            font-size: 12px;
            display: flex;
            justify-content: center;
            align-content: center;

            .sc-chat-footer-text {
                padding: 5px 10px;
                color: #9E9DA2;
                background-color: #f2f6fc54 !important;

                a {
                    text-decoration: none;
                }
            }

            .sc-chat-footer-text:hover {
                padding-left: 10px;
                padding-right: 10px;
                background-color: #ecf0f1;
                cursor: pointer;
                border-radius: 15px;
            }
        }

        &__foter {
            flex: 0 1 30px;
            box-shadow: rgba(0, 0, 0, 0.16) 0 5px 40px;
        }
    }

    .sc-chat-window.closed {
        opacity: 0;
        display: none;
        bottom: 90px;
    }

    .sc-message--me {
        text-align: right;
    }
    .sc-message--them {
        text-align: left;
    }

    @media (max-width: 450px) {
        .sc-chat-window {
            width: 100%;
            height: 100%;
            max-height: 100%;
            right: 0px;
            bottom: 0px;
            border-radius: 0px;
        }

        .sc-chat-window {
            transition: 0.1s ease-in-out;
        }

        .sc-chat-window.closed {
            bottom: 0px;
        }
    }
</style>
